<template lang="pug">
  .component-create-vehicle-category
    modal-reveal(sizing="small", ref="modalEditVehicleCategory")
      a(slot="trigger") Edit
      h2 Edit Vehicle Category {{item.id}} - {{item.name}}
      .row
        .column
          label Name
            input(type="text", v-model="item.name")
          label Description
            textarea(rows="5", v-model="item.description")
          label Category damage picture
          KeplerFileUpload(selected-prefix="damage-picture", selected-visibility="public", @sel="handleFileDamageSelector", :previewUrl="item.damage_picture")
        .column
          label Vehicle Types
            select(v-model="item.vehicle_type.id")
              option(v-for="vehicleType in vehicleTypes", :value="vehicleType.id") {{vehicleType.name}}
          label Category image
          KeplerFileUpload(selected-prefix="vehicle-categories", selected-visibility="public", @sel="handleFileSelector", :previewUrl="item.picture")


            //label Picture
            //dropzone(:url="dropzoneUrl", :id="_uid+'-create-vc'", :maxNumberOfFiles="1", @vdropzone-success='uploaded' @vdropzone-removed-file="removeAttachment")

      .row.column
        button.button(@click="editVehicleCategory") Edit
</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import Dropzone from '../../../Dropzone'
  import MaggieHelper from '../../../../../maggieHelper'
  import KeplerFileUpload from '../../../KeplerFileUpload'

  export default {
    name: 'EditVehicleCategory',
    components: {KeplerFileUpload, Dropzone, ModalReveal},
    data() {
      return {
        dropzoneUrl: KeplerBackofficeSdk.getUrlForDropzone(),
        vehicleTypes: null
      }
    },
    created() {

      KeplerBackofficeSdk.vehicleTypes.list.all((data) => {
        this.vehicleTypes = data
      })
    },
    methods: {
      editVehicleCategory() {
        this.item.vehicle_type_id = this.item.vehicle_type.id
        KeplerBackofficeSdk.vehicleCategories.select(this.item.id).edit(this.item, () => {
          MaggieHelper.notification('Edit', 'Vehicle category updated')
          this.$refs.modalEditVehicleCategory.close()
        })
      },
      handleFileSelector(path) {
        this.item.picture = path
      },
      handleFileDamageSelector(path) {
        this.item.damage_picture = path
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditVehicleCategory.vue?2d45f664